type option = {
    label: string
    value: string
}

export const coverOptionsToArray = (coverOptions: String): Array<option> => {
    let list = coverOptions.split('~~')

    let dropdownOptions: Array<option> = []
    dropdownOptions = list.map((e: String) => {
        let labelAndPayload = e.split('||')
        if (labelAndPayload.length !== 2)
            console.error('Expected 2 values per option. Please specify options in the form "label||/payload~~label2||/payload2"')
        return { value: labelAndPayload[1], label: labelAndPayload[0] }
    })
    return dropdownOptions
}

export const getPayloadFromCoverOption = (coverOptions:String, message: String): String | undefined => {
    let options = coverOptionsToArray(coverOptions)
    return options.find(option => option.label === message)?.value
}
